import * as constants from './AllCourses.constants';
import * as services from './AllCourses.service';

const state = {
  MainCourses: [],
  MiniCourses: [],
};

const mutations = {
  [constants.GET_ALL_COURSES_SUCCESS](state, data) {
    state.MainCourses = data.mainCourses;
    state.MiniCourses = data.miniCourses;
  },
};

const actions = {
  async getAllCourses({ commit }, payload) {
    try {
      const res = await services.getAllCourses(payload);
      if (res.data.data) {
        commit(constants.GET_ALL_COURSES_SUCCESS, res.data.data);
      }
    } catch (e) {
      commit(constants.GET_ALL_COURSES_SUCCESS, {
        mainCourses: [],
        miniCourses: [],
      });
    }
  },
};

const getters = {
  MainCourses: state => state.MainCourses,
  MiniCourses: state => state.MiniCourses,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
